const VectorDown = () => {
  return (
    <svg
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.62401 6.77311L3.62403 0.892299L3.36422 0.892299L3.36419 6.77311L0.886843 4.29576L0.713618 4.46899L3.49414 7.24951L6.27466 4.46899L6.10144 4.29576L3.62401 6.77311Z"
        fill="black"
        stroke="black"
        stroke-width="0.75"
      />
    </svg>
  );
};

export default VectorDown;
